import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import FreqPowerCard from "../DeviceFreqToPower/FreqPowerCard";
import { AllowedConversionType, convertCapabilityName, isJsonParseSuccessful, isJsonStringifySuccessful, validateJSONData } from "../../../utils/general";
import { FormControl, InputLabel, Box } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import FormInput from "../../Common/FormInputs/MuiTextField";
import { selectMenuProps } from "../../../utils/selectMenuProps";


const labelColorStyle = { color: "#000" };
const selectInputSx = { height: "3rem", width: "100%" };
const capabilityListDropdownSx = { marginTop: "20px", marginBottom: "20px" };
const addCapabilityButtonSx = { marginTop: "45px", marginBottom: "20px" };
const capabilityCardSx = { marginBottom: "15px", backgroundColor: "#f2f2f2" };
const deleteCapabilityCardButtonSx = { float: "right" };
const selectValuesSx = { width: "100%" };
const attributeKeySx = { marginRight: '20px' };

const CONFIG = {
  customJson: {
    label: "Custom Capability JSON",
    placeholder: `e.g., {"capability": "PowerfulMode","attributes": [{"key": "acpm"}]} `,
    rows: 4,
    helpText: "Valid JSON format is required",
  },
};

const DeviceModelStatusCapability = ({
    productCategory,
    isDeviceModelAddedUsingFileUpload,
    triggerAddNewDeviceModel,
    addDeviceStatusCapabilties,
    editDeviceModel,
    deviceModelData,
    ModelData: { deviceModelsMetadata },
    freqPowerBodies,
    setFreqPowerBodies,
    removeFreqPowerRow,
    addFreqPowerRow,
    freqToPowerData,
    initialFreqPower,
    areAllCustomJsonValidCheck
}) => {
    // const [statusCapabiltiesList, setStatusCapabiltiesList] = useState(Object.keys(deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities ?? {}).sort())
    const customCapabilityName = "CustomCapability";
    const [customCapabilityCount, setCustomCapabilityCount] = useState(1);
    const [statusCapabiltiesList, setStatusCapabiltiesList] = useState(() => {
        const capabilities = Object.keys(
            deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities ?? {}
        ).sort();

        return Array.from(
            new Set([customCapabilityName, ...capabilities])
        );
    });
    const [selectedStatusCapability, setSelectedStatusCapability] = useState(Object.keys(deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities ?? {}).sort()?.[0] ?? "")
    const [addedStatusCapabilities, setAddedStatusCapabilities] = useState([])
    const [statusCapabilitiesAttributes, setStatusCapabilitiesAttributes] = useState({})

    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const areAllCustomJsonValid = (errorsObj) => {
        return Object.values(errorsObj).every(error => error === "");
    };

    useEffect(() => {
        let nextSelectedCapability = ""
        if (statusCapabiltiesList && statusCapabiltiesList.length > 0) {
            nextSelectedCapability = statusCapabiltiesList[0]
        }
        setSelectedStatusCapability(nextSelectedCapability)

    }, [statusCapabiltiesList])

    useEffect(() => {
        let stsCapabilitiesAttributes = {}

        if (editDeviceModel || isDeviceModelAddedUsingFileUpload) {
            let statusCapabilities = deviceModelData.statusCapabilitiesV2?deviceModelData.statusCapabilitiesV2:[];

            for (let capability of statusCapabilities) {
                let capabilityName = capability['capability']
                if( (deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities) && !([capabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities)){
                    stsCapabilitiesAttributes[[capabilityName]] = isJsonStringifySuccessful(capability, {formatted: true})
                }
                else{
                    stsCapabilitiesAttributes[capabilityName] = {}
                    let attributes = capability['attributes'];

                    if (attributes) {
                        stsCapabilitiesAttributes[capabilityName]["attributes"] = {}

                        for (let index in attributes) {
                            stsCapabilitiesAttributes[capabilityName]["attributes"][index] = {}
                            stsCapabilitiesAttributes[capabilityName]["attributes"][index]['key'] = attributes[index]['key']
                        }
                    }
                }
            }
        }

        let statusCapabilities = deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities;
        if (statusCapabilities) {
            for (let capabilityName in statusCapabilities) {

                if (stsCapabilitiesAttributes.hasOwnProperty(capabilityName)) {
                    continue;
                }

                stsCapabilitiesAttributes[capabilityName] = {}
                let attributes = statusCapabilities[capabilityName]['attributes'];
                if (attributes) {
                    stsCapabilitiesAttributes[capabilityName]["attributes"] = {}

                    for (let index in attributes) {
                        stsCapabilitiesAttributes[capabilityName]["attributes"][index] = {}
                        stsCapabilitiesAttributes[capabilityName]["attributes"][index]['key'] = attributes[index]['key'] ? attributes[index]['key'] : ""
                    }
                }
            }
        }
        setStatusCapabilitiesAttributes(stsCapabilitiesAttributes)

    }, [productCategory, editDeviceModel, isDeviceModelAddedUsingFileUpload])

    useEffect(() => {
        if (editDeviceModel || isDeviceModelAddedUsingFileUpload) {
            let addedStatusCapabilitiesList = []
            const statusCapabilitiesV2 = deviceModelData?.statusCapabilitiesV2 || [];
            for (let statusCapability of statusCapabilitiesV2) {
                addedStatusCapabilitiesList.push(statusCapability.capability)
            }

            setAddedStatusCapabilities(addedStatusCapabilitiesList);
            setStatusCapabiltiesList((prevState) => {
                // return prevState.filter((capabilityName) => !(addedStatusCapabilitiesList.includes(capabilityName))).sort();
                return prevState.filter((capabilityName) => !(addedStatusCapabilitiesList.includes(capabilityName)));
            });
        } else {
            // setStatusCapabiltiesList(deviceModelsMetadata["categories"][productCategory] ? Object.keys(deviceModelsMetadata["categories"][productCategory]["statusCapabilities"]) : []);
            setStatusCapabiltiesList(() => {
            const capabilities =
                deviceModelsMetadata["categories"][productCategory]
                ? Object.keys(deviceModelsMetadata["categories"][productCategory]["statusCapabilities"]).sort()
                : [];

            return [
                customCapabilityName,
                ...capabilities.filter(cap => cap !== customCapabilityName),
            ];
            });
            setAddedStatusCapabilities([]);
        }
    }, [productCategory, editDeviceModel, isDeviceModelAddedUsingFileUpload])

    useEffect(() => {
        if (triggerAddNewDeviceModel) {
            let statusCapabilitiesData = getStatusCapabilityData();
            addDeviceStatusCapabilties(statusCapabilitiesData)
            areAllCustomJsonValidCheck(areAllCustomJsonValid(errors), "status")
        }
    }, [triggerAddNewDeviceModel])

    function handleSelectStatusCapability(selectedCapability) {
        setSelectedStatusCapability(selectedCapability)
    }

    function handleAddStatusCapability(addedCapabilityName) {        
        if(addedCapabilityName === customCapabilityName){
            addedCapabilityName = addedCapabilityName + customCapabilityCount;

            setStatusCapabilitiesAttributes(prev => ({
                ...prev,
                [addedCapabilityName]: isJsonStringifySuccessful({}, {formatted: true})
            }));

            setAddedStatusCapabilities((prevState) => {
                return [...prevState, addedCapabilityName]
            })

            setCustomCapabilityCount((prev) => prev + 1);
        }
        else{
            setAddedStatusCapabilities((prevState) => {
                return [...prevState, addedCapabilityName]
            })

            setStatusCapabiltiesList((prevState) => {
                // return prevState.filter((capabilityName) => capabilityName!==selectedStatusCapability).sort()
                return prevState.filter((capabilityName) => capabilityName!==selectedStatusCapability)
            })
        }
    }

    const isCustomCapability = (value) => value.startsWith(customCapabilityName);

    function handleRemoveStatusCapability(removedCapabilityName) {
        // handle custom removal logic
        if ((isCustomCapability(removedCapabilityName)) || !((deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities) && ([removedCapabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities)) ) {
            setStatusCapabilitiesAttributes(prev => {
                const { [removedCapabilityName]: _, ...rest } = prev;
                return rest;
            });

            setAddedStatusCapabilities((prevState) => {
                return prevState.filter((capabilityName) => capabilityName!==removedCapabilityName).sort()
            })

            setErrors(prev => {
                const { [removedCapabilityName]: _, ...rest } = prev;
                return rest;
            });

            setTouched(prev => {
                const { [removedCapabilityName]: _, ...rest } = prev;
                return rest;
            });
        }
        else{
            setAddedStatusCapabilities((prevState) => {
                return prevState.filter((capabilityName) => capabilityName!==removedCapabilityName).sort()
            })

            setStatusCapabiltiesList((prevState) => {
                return [...prevState, removedCapabilityName]
            })

            if (removedCapabilityName === "PowerConsumption") {
                setFreqPowerBodies([{ frequency: "", rrpm_c: "", power: "" }]);
            }
        }
    }

    function onChangeCapabilityCustomJson(capabilityName, value) {
        let capabilityAttributes = { ...statusCapabilitiesAttributes }

        capabilityAttributes[capabilityName] = value

        handleStatusCapabilitiesAttributes(capabilityAttributes)

        const error = validateJSONData(value);
        setErrors((prev) => ({ ...prev, [capabilityName]: error }));
        if (error && error !== "") {
            setTouched((prev) => ({ ...prev, [capabilityName]: "true" }));
        }
    }

    function onChangeAttributeKeyName(capabilityName, attributeIndex, keyName) {
        let capabilityAttributes = { ...statusCapabilitiesAttributes }
        capabilityAttributes[capabilityName]["attributes"][attributeIndex]["key"] = keyName

        handleStatusCapabilitiesAttributes(capabilityAttributes)
    }

    function handleStatusCapabilitiesAttributes(capabilityAttributes) {
        setStatusCapabilitiesAttributes(capabilityAttributes)
    }

    function getStatusCapabilityData() {
        let statusCapabilities = []
        for (let capabilityName of addedStatusCapabilities) {
            if( (isCustomCapability(capabilityName)) || !((deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities) && ([capabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities)) ){
                if(isJsonParseSuccessful(statusCapabilitiesAttributes[capabilityName], { logError: false }) !== false){
                    statusCapabilities.push(isJsonParseSuccessful(statusCapabilitiesAttributes[capabilityName]))
                }
            }
            else{
                let capabilityData = {}
                capabilityData['capability'] = capabilityName

                let attributes = statusCapabilitiesAttributes[capabilityName]['attributes'];
                if(attributes){
                    capabilityData['attributes'] = []
                }
                for (let index in attributes) {
                    let attributeData = {}
                    attributeData['key'] = attributes[index]['key']
                    capabilityData['attributes'].push(attributeData)
                }

                statusCapabilities.push(capabilityData)
            }
        }
        return statusCapabilities;
    }

    return (
        <Fragment>
            <div className="row">
                <Box className="s4 col" sx={capabilityListDropdownSx}>
                    <label className="title d-inline min-180 mb-5 mt-20">Select Capability</label>
                    <Select
                        value={selectedStatusCapability}
                        onChange={(e) => {
                            handleSelectStatusCapability(e.target.value)
                        }}
                        displayEmpty
                        input={<OutlinedInput />}
                        inputProps={{ 'aria-label': 'Without label' }}
                        sx={selectInputSx}
                        MenuProps={selectMenuProps}
                    >
                        {/* {
                            statusCapabiltiesList?.sort().map((capabilityName) => {
                                return <MenuItem key={capabilityName} value={capabilityName}>{convertCapabilityName(capabilityName)}</MenuItem>
                            })
                        } */}
                        {
                            statusCapabiltiesList?.map((capabilityName) => {
                                return <MenuItem key={capabilityName} value={capabilityName}>{convertCapabilityName(capabilityName)}</MenuItem>
                            })
                        }
                    </Select>
                </Box>
                <div className={`s4 col`}>
                    <button
                        className="btn btn-style-2 orange-bg mr-5" style={addCapabilityButtonSx}
                        onClick={() => {
                            handleAddStatusCapability(selectedStatusCapability)
                        }}
                        disabled={statusCapabiltiesList && statusCapabiltiesList.length===0}
                    >
                        Add Capability
                    </button>
                </div>
            </div>
            {
                addedStatusCapabilities.map((capabilityName) => {
                    return <Fragment key={productCategory + '_' + capabilityName}>
                        <Card variant="outlined" sx={capabilityCardSx} key={capabilityName}>
                            { (isCustomCapability(capabilityName)
                                || !((deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities) && ([capabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities))
                            ) ?
                                <CardContent>
                                    <Grid2 container alignItems="flex-start" spacing={1}>
                                        <Grid2 size={10} sx={{margin: 'auto'}}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                            {CONFIG?.customJson?.label}
                                            </Typography>
                                        </Grid2>
    
                                        <Grid2 size={2} display="flex" justifyContent="flex-end">
                                            <IconButton
                                            aria-label="delete"
                                            onClick={() => handleRemoveStatusCapability(capabilityName)}
                                            sx={{ p: 0.5 }}
                                            >
                                            <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Grid2>
    
                                        <FormInput
                                            id={capabilityName}
                                            name={capabilityName}
                                            type="textarea"
                                            multiline
                                            rows={CONFIG?.customJson?.rows}
                                            fullWidth
                                            value={statusCapabilitiesAttributes[capabilityName]}
                                            onChange={(e) => onChangeCapabilityCustomJson(capabilityName, e.target.value)}
                                            placeholder={CONFIG?.customJson?.placeholder}
                                            error={!!errors?.[capabilityName]}
                                            touched={touched[capabilityName]}
                                            helperText={errors?.[capabilityName] || CONFIG?.customJson?.helpText}
                                            sx={{
                                            "& .MuiOutlinedInput-input": {
                                                padding: "2px 6px !important",
                                                height: "130px !important",
                                            },
                                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderWidth: `2px solid !important`,
                                            },
                                            }}
                                            slotProps={{
                                                htmlInput: {
                                                    maxLength: 10000,
                                                },
                                            }}
                                        />
                                    </Grid2>
                                </CardContent>
                                :
                            <CardContent>
                                <Grid container xs={12}>
                                    <Grid item xs={11}>
                                        <Typography variant="button">{convertCapabilityName(capabilityName)}</Typography>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <IconButton aria-label="delete" onClick={(e) => {
                                            handleRemoveStatusCapability(capabilityName)
                                        }} sx={deleteCapabilityCardButtonSx}>
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                {deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities?.[capabilityName]?.attributes?.map((element, index) => {
                                        return <Grid key={capabilityName + '_' + index} container>
                                            <Grid item xs={1}>
                                                <Typography>Attribute</Typography>
                                            </Grid>
                                            <Grid item xs={4} sx={attributeKeySx}>
                                                <input
                                                    placeholder="Enter Key Name"
                                                    className="add-input xl"
                                                    value={statusCapabilitiesAttributes[capabilityName]?.["attributes"]?.[index]?.["key"]}
                                                    type="text"
                                                    disabled={true}
                                                    onChange={(e) => {
                                                        onChangeAttributeKeyName(capabilityName, index, e.target.value)
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    })}
                                {productCategory === "AC" && capabilityName === "PowerConsumption" && (
                                    <>
                                    
                                    <div style={{ marginTop: "10px" }}>
                                      <FreqPowerCard
                                        bodies={freqPowerBodies}
                                        setBodies={setFreqPowerBodies}
                                        onRemove={removeFreqPowerRow}
                                        disabled={initialFreqPower.length===15 ? editDeviceModel : false}                                      />
                                       {freqPowerBodies.length < 15 && (
                                        <button
                                            className="btn btn-style-2 orange-bg mt-10"
                                            onClick={addFreqPowerRow}
                                        >
                                            Add Record
                                        </button>
                                       )}
                                    </div>
                                    </>
                                  )}
                            </CardContent>
                            }
                        </Card>
                    </Fragment>
                })
            }
        </Fragment>
    )
}

const mapStateToProps = (state) => ({
    ModelData: state.getModel,
    freqToPowerData: state.report.freqToPowerData
});

export default connect(mapStateToProps)(DeviceModelStatusCapability);